import { Component, Input, OnChanges } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-course-information-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent
  ],
  templateUrl: './course-information-form.component.html',
  styleUrl: './course-information-form.component.scss'
})
export class CourseInformationFormComponent implements OnChanges {
  @Input() itemId: string = '';
  @Input() modalInstance: any = null;

  item: any = {};
  organisations: any = {};
  errorMessage: any = {};
  errors: any = {};
  loading: boolean = false;
  newPassword: string = '';

  constructor(
    private apiService: ApiService,
  ) {
  }

  ngOnChanges(changes: any) {
    this.getItem();
    this.getOrganisations();
  }

  save() {
    let self = this;

    self.reset();
    self.loading = true;

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.scrollTo({ top: 0, behavior: 'smooth' });
    }

    let method: string = 'put';
    if (this.itemId === '') {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.post('/office/courses', postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
    else {
      let postData = this.item;
      postData['password'] = self.newPassword;

      return this.apiService.put('/office/courses/' + this.item['id'], postData).then(function (response: any) {
        self.handleSucces(response);
      }).catch(function (e) {
        self.handleError(e);
      });
    }
  }

  handleSucces(response: any) {
    let self = this;
    self.item = response;
    setTimeout(function () {
      self.loading = false;
      self.modalInstance.dismiss('');
    }, 200);
  }

  handleError(response: any) {
    let self = this;
    self.errors = response['error']['error'];
    self.errorMessage = response['error']['message'];
    self.loading = false;

    if (response.status == 500) {
      self.errorMessage = response['error']['message'];
      self.errors = [];
    }
  }

  reset() {
    this.errors = {};
    this.errorMessage = '';
  }

  getOrganisations() {
    let self = this;

    return this.apiService.get('/office/organisations').then(function (response: any) {
      self.organisations = response;
    }).catch(function (e) {
    });
  }

  getItem() {
    let itemId = this.itemId;
    let self = this;

    self.reset();
    if (this.itemId === '') {
      return;
    }
    return this.apiService.get('/office/courses/' + itemId).then(function (response: any) {
      self.item = response;
      setTimeout(function () { self.loading = false; }, 200);
    }).catch(function (e) {
      self.loading = false;
    });
  }
}
